export default {
  text: 'Vahvista {{provider}}:lla',
  text_generic: 'Vahvista maksupalveluntarjoajallasi',
  error: '{{provider}}-lomaketta ei voitu avata. Yritä uudelleen.',
  error_generic: 'Maksupalveluntarjoajan lomaketta ei voitu avata. Yritä uudelleen.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
